import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AppConfigService } from "@app-shared/services";
import { HttpUtilHelper } from "src/shared/helpers/http-util-helper";
import { ImportCreditEnhancementAdjustmentFactorsFileApiResponse } from "./models/ImportCreditEnhancementAdjustmentFactorsFileApiResponse";
import { GetCreditEnhancementGridModelVersionsApiResponse } from "./models/GetCreditEnhancementGridModelVersionsApiResponse";
import { CreditEnhancementGridModelVersionResponse } from "./models/inner/CreditEnhancementGridModelVersionResponse";
import { IDeleteCreditEnhancementGridDataApiResponse } from "./models/DeleteCreditEnhancementGridDataApiResponse";

@Injectable({
    providedIn: 'root'
})
export class ConfigureService {
    updateCeGridModelVersionStatus(arg0: { id: number; active: boolean; }) {
        throw new Error('Method not implemented.');
    }

    private API_PATH = `${AppConfigService.Settings.Mpf.ApiEndpoint}`;
    private BUILT_API_PATH = `${this.API_PATH}/api/creditenhancement`;
    private API_SERVICE_PATH = `${this.BUILT_API_PATH}/configure`;
    private options: object = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    private websocketOptions(connectionId: string) 
    { return { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'connectionid': `${connectionId}` }) } }
       

    constructor(private http: HttpClient) { }

    ImportCreditEnhancementAdjustmentFactorsFile(): Observable<ImportCreditEnhancementAdjustmentFactorsFileApiResponse> {
        return this.http.put<ImportCreditEnhancementAdjustmentFactorsFileApiResponse>(`${this.API_SERVICE_PATH}/${"ImportCreditEnhancementAdjustmentFactorsFile".toLowerCase()}`, this.options
        ).pipe(map(response => response));
    }

  GetCreditEnhancementGridModelVersions(): Observable<CreditEnhancementGridModelVersionResponse[]> {
    return this.http.get<GetCreditEnhancementGridModelVersionsApiResponse>(
      `${this.API_SERVICE_PATH}/${"GetCreditEnhancementGridModelVersions".toLowerCase()}`,
      this.options
    ).pipe(
      map(response => {
        return response.creditEnhancementGridModelVersions || [];
      })
    );
  }

  InsertCreditEnhancementGridModelVersion(model: any): Observable<any> {
    return this.http.post<any>(
      `${this.API_SERVICE_PATH}/${"InsertCreditEnhancementGridModelVersion".toLowerCase()}`,
      model,
      this.options
    ).pipe(
      map(response => response)
    );
  }

  UpdateCreditEnhancementGridModelVersion(model: any): Observable<any> {
    return this.http.post<any>(
      `${this.API_SERVICE_PATH}/${"UpdateCreditEnhancementGridModelVersion".toLowerCase()}`,
      model,
      this.options
    ).pipe(
      map(response => response)
    );
  }

  ImportCreditEnhancementGridFile(request: any): Observable<any> {
    return this.http.put<any>(
      `${this.API_SERVICE_PATH}/${"ImportCreditEnhancementGridFile".toLowerCase()}`,
      request,
      {
        ...this.options,
        observe: 'response'
      } as any
    ).pipe(
      map(response => response)
    );
  }

   DeleteCreditEnhancementGridData(connectionId: string, CEGridModelVersion: string): Observable<IDeleteCreditEnhancementGridDataApiResponse>  {
        return this.http.delete<IDeleteCreditEnhancementGridDataApiResponse>(
          `${this.API_SERVICE_PATH}/${"DeleteCreditEnhancementGridData".toLowerCase()}?CEGridModelVersion=${CEGridModelVersion}`,
          this.websocketOptions(connectionId)
        ).pipe(map(response => response));
      }
      
}
